import { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import LogoutIcon from '@mui/icons-material/Logout'
import MenuIcon from '@mui/icons-material/Menu'

/* Keep this commented code for future reference */
// import UserProfileIcon from '@mui/icons-material/Person'

import useAuth from '../../hooks/useAuth'
import ConfirmDialog from '../shared/ConfirmDialog'
import { EndSessionText, Header, ImpersonationChip, RightSide, Subtitle, Title } from './TopBar.styles'

interface TopBarProps {
  title?: string
  subtitle?: string
  impersonating?: string
  onMenuClick?: () => void
}

const TopBar = ({ title = 'Dashboard', subtitle, impersonating, onMenuClick }: TopBarProps): React.JSX.Element => {
  const { logout } = useAuth()
  const [logoutOpen, setLogoutOpen] = useState(false)

  return (
    <Header>
      <Tooltip title="Toggle sidebar">
        <IconButton size="small" onClick={onMenuClick} aria-label="toggle sidebar">
          <MenuIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <div>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </div>

      {impersonating && (
        <ImpersonationChip
          icon={<WarningAmberIcon fontSize="small" />}
          label={`Impersonating ${impersonating}`}
          color="warning"
          size="small"
          onDelete={logout}
          deleteIcon={<EndSessionText>End Session</EndSessionText>}
        />
      )}

      <RightSide>
        {/* Keep this commented code for future reference */}
        {/* <Tooltip title="User Profile">
          <IconButton size="small">
            <UserProfileIcon fontSize="small" />
          </IconButton>
        </Tooltip> */}
        <Tooltip title="Logout">
          <IconButton size="small" onClick={() => setLogoutOpen(true)} aria-label="logout">
            <LogoutIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </RightSide>

      <ConfirmDialog
        open={logoutOpen}
        title="Logout"
        message="Are you sure you want to log out of your session?"
        confirmLabel="Logout"
        onClose={() => setLogoutOpen(false)}
        onConfirm={() => {
          setLogoutOpen(false)
          logout()
        }}
      />
    </Header>
  )
}

export default TopBar
